/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime'
import type {
  ApplicationStatus,
  CheckPaymentRequired200Response,
  CreateStateDutyOrder400Response,
  CreateStateDutyOrderRequest,
  DeleteApplication200Response,
  DeleteApplication400Response,
  GetAddressSuggest401Response,
  GetAddressSuggest403Response,
  GetApplication200Response,
  GetApplicationDocument400Response,
  GetApplicationDocument404Response,
  GetApplicationList200Response,
  GetApplicationList422Response,
  GetCommonState400Response,
  GetCommonState403Response,
  GetCommonState404Response,
  GetFeePaymentDocument400Response,
  GetFeePaymentDocument422Response,
  GetMktuList200Response,
  PayOrder200Response,
} from '../models/index'
import {
  ApplicationStatusFromJSON,
  ApplicationStatusToJSON,
  CheckPaymentRequired200ResponseFromJSON,
  CheckPaymentRequired200ResponseToJSON,
  CreateStateDutyOrder400ResponseFromJSON,
  CreateStateDutyOrder400ResponseToJSON,
  CreateStateDutyOrderRequestFromJSON,
  CreateStateDutyOrderRequestToJSON,
  DeleteApplication200ResponseFromJSON,
  DeleteApplication200ResponseToJSON,
  DeleteApplication400ResponseFromJSON,
  DeleteApplication400ResponseToJSON,
  GetAddressSuggest401ResponseFromJSON,
  GetAddressSuggest401ResponseToJSON,
  GetAddressSuggest403ResponseFromJSON,
  GetAddressSuggest403ResponseToJSON,
  GetApplication200ResponseFromJSON,
  GetApplication200ResponseToJSON,
  GetApplicationDocument400ResponseFromJSON,
  GetApplicationDocument400ResponseToJSON,
  GetApplicationDocument404ResponseFromJSON,
  GetApplicationDocument404ResponseToJSON,
  GetApplicationList200ResponseFromJSON,
  GetApplicationList200ResponseToJSON,
  GetApplicationList422ResponseFromJSON,
  GetApplicationList422ResponseToJSON,
  GetCommonState400ResponseFromJSON,
  GetCommonState400ResponseToJSON,
  GetCommonState403ResponseFromJSON,
  GetCommonState403ResponseToJSON,
  GetCommonState404ResponseFromJSON,
  GetCommonState404ResponseToJSON,
  GetFeePaymentDocument400ResponseFromJSON,
  GetFeePaymentDocument400ResponseToJSON,
  GetFeePaymentDocument422ResponseFromJSON,
  GetFeePaymentDocument422ResponseToJSON,
  GetMktuList200ResponseFromJSON,
  GetMktuList200ResponseToJSON,
  PayOrder200ResponseFromJSON,
  PayOrder200ResponseToJSON,
} from '../models/index'

export interface CheckPaymentRequiredRequest {
  applicationId: string
}

export interface CreateStateDutyOrderOperationRequest {
  createStateDutyOrderRequest: CreateStateDutyOrderRequest
}

export interface DeleteApplicationRequest {
  applicationId: string
}

export interface GetApplicationRequest {
  applicationId: string
}

export interface GetApplicationDocumentRequest {
  applicationId: string
  documentId: string
  type?: GetApplicationDocumentTypeEnum
}

export interface GetApplicationListRequest {
  search?: string
  status?: ApplicationStatus
  page?: number
  perPage?: number
}

export interface GetFeePaymentDocumentRequest {
  applicationId: string
  type?: GetFeePaymentDocumentTypeEnum
}

export interface GetMktuListRequest {
  applicationId: string
}

/**
 * ApplicationApi - interface
 *
 * @export
 * @interface ApplicationApiInterface
 */
export interface ApplicationApiInterface {
  /**
   * Проверка, требуется ли и возможна ли оплата госпошлины по заявке. Признак paymentAllowed собирается из двух независимых проверок: анализ статуса заявки и истории оплат через эквайринг (CheckUserCanPayAction) и флаг allow_fee_payment в jsonb-опциях заявки для полу-цифровых продуктов (CheckApplicationOptionsAllowPaymentAction). Оплата доступна, только если обе проверки пройдены. Требуется подтверждённый email.
   * @summary Проверка возможности оплаты пошлины
   * @param {string} applicationId Порядковый номер заявления в системе
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ApplicationApiInterface
   */
  checkPaymentRequiredRaw(
    requestParameters: CheckPaymentRequiredRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CheckPaymentRequired200Response>>

  /**
   * Проверка, требуется ли и возможна ли оплата госпошлины по заявке. Признак paymentAllowed собирается из двух независимых проверок: анализ статуса заявки и истории оплат через эквайринг (CheckUserCanPayAction) и флаг allow_fee_payment в jsonb-опциях заявки для полу-цифровых продуктов (CheckApplicationOptionsAllowPaymentAction). Оплата доступна, только если обе проверки пройдены. Требуется подтверждённый email.
   * Проверка возможности оплаты пошлины
   */
  checkPaymentRequired(
    requestParameters: CheckPaymentRequiredRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CheckPaymentRequired200Response>

  /**
   * Создание заказа на оплату госпошлины (первая/вторая пошлина по зТЗ) для объекта SysObject текущего пользователя; вместе с заказом создаётся платёж. Требуется подтверждённый email.
   * @summary Заказ на оплату госпошлины
   * @param {CreateStateDutyOrderRequest} createStateDutyOrderRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ApplicationApiInterface
   */
  createStateDutyOrderRaw(
    requestParameters: CreateStateDutyOrderOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PayOrder200Response>>

  /**
   * Создание заказа на оплату госпошлины (первая/вторая пошлина по зТЗ) для объекта SysObject текущего пользователя; вместе с заказом создаётся платёж. Требуется подтверждённый email.
   * Заказ на оплату госпошлины
   */
  createStateDutyOrder(
    requestParameters: CreateStateDutyOrderOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PayOrder200Response>

  /**
   * Удаление заявления текущего пользователя. Допускается только для заявлений в статусах Draft, Created и Create; при наличии хотя бы одного оплаченного ордера по заявке удаление запрещено. Требуется подтверждённый email.
   * @summary Удаление заявки
   * @param {string} applicationId Порядковый номер заявления в системе
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ApplicationApiInterface
   */
  deleteApplicationRaw(
    requestParameters: DeleteApplicationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<DeleteApplication200Response>>

  /**
   * Удаление заявления текущего пользователя. Допускается только для заявлений в статусах Draft, Created и Create; при наличии хотя бы одного оплаченного ордера по заявке удаление запрещено. Требуется подтверждённый email.
   * Удаление заявки
   */
  deleteApplication(
    requestParameters: DeleteApplicationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<DeleteApplication200Response>

  /**
   * Полные данные карточки заявки текущего пользователя: статусы (текущий/прошлый), состояние документов, причина проблемы, номер регистрации и сертификата, данные правообладателя, изображение знака, аналитические документы по этапам, ссылка на источник ФИПС. Поле linkInAdmin возвращается только админским аккаунтам. Требуется подтверждённый email.
   * @summary Данные заявки
   * @param {string} applicationId Порядковый номер заявления в системе
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ApplicationApiInterface
   */
  getApplicationRaw(
    requestParameters: GetApplicationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetApplication200Response>>

  /**
   * Полные данные карточки заявки текущего пользователя: статусы (текущий/прошлый), состояние документов, причина проблемы, номер регистрации и сертификата, данные правообладателя, изображение знака, аналитические документы по этапам, ссылка на источник ФИПС. Поле linkInAdmin возвращается только админским аккаунтам. Требуется подтверждённый email.
   * Данные заявки
   */
  getApplication(
    requestParameters: GetApplicationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetApplication200Response>

  /**
   * Выдача файла документа делопроизводства по заявке: поток с Content-Type и именем файла из документа (обычно application/pdf), а не конверт success_response. Служебные значения documentId — egr_document / extract_document — доступны только для заявок в статусе EGR. Требуется подтверждённый email.
   * @summary Файл документа заявки
   * @param {string} applicationId Порядковый номер заявления в системе
   * @param {string} documentId UUID документа либо служебные значения egr_document / extract_document
   * @param {'inline' | 'attachment'} [type] Тип Content-Disposition выдачи файла (по умолчанию inline)
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ApplicationApiInterface
   */
  getApplicationDocumentRaw(
    requestParameters: GetApplicationDocumentRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Blob>>

  /**
   * Выдача файла документа делопроизводства по заявке: поток с Content-Type и именем файла из документа (обычно application/pdf), а не конверт success_response. Служебные значения documentId — egr_document / extract_document — доступны только для заявок в статусе EGR. Требуется подтверждённый email.
   * Файл документа заявки
   */
  getApplicationDocument(
    requestParameters: GetApplicationDocumentRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Blob>

  /**
   * Постраничный список заявок текущего пользователя. Сортировка — по дате последней загрузки документов (по убыванию). Если параметр status не передан, завершённые заявки (FILTER_STATUS_ISSUED) исключаются из выдачи. Рядом с data возвращаются pagination (мета пагинации) и meta (количество заявок по вкладкам статусов, без учёта фильтра status). Требуется подтверждённый email.
   * @summary Список заявок пользователя
   * @param {string} [search] Поиск знака по подстроке (по метаданным заявки, без учёта регистра)
   * @param {ApplicationStatus} [status] Вкладка статуса заявки (имя кейса ApplicationFilterStatusesEnum)
   * @param {number} [page] Номер страницы (по умолчанию 1)
   * @param {number} [perPage] Записей на странице, 1–100 (по умолчанию — из настроек сервера)
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ApplicationApiInterface
   */
  getApplicationListRaw(
    requestParameters: GetApplicationListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetApplicationList200Response>>

  /**
   * Постраничный список заявок текущего пользователя. Сортировка — по дате последней загрузки документов (по убыванию). Если параметр status не передан, завершённые заявки (FILTER_STATUS_ISSUED) исключаются из выдачи. Рядом с data возвращаются pagination (мета пагинации) и meta (количество заявок по вкладкам статусов, без учёта фильтра status). Требуется подтверждённый email.
   * Список заявок пользователя
   */
  getApplicationList(
    requestParameters: GetApplicationListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetApplicationList200Response>

  /**
   * Генерация платёжного поручения (PDF) на оплату госпошлины по заявке: первой пошлины — для заявок в статусе FE, второй — для заявок в статусе CompletedEOS; в остальных статусах генерация запрещена. Файл отдаётся потоком (Content-Type: application/pdf), а не в конверте success_response. Требуется подтверждённый email.
   * @summary Платёжное поручение по пошлине (PDF)
   * @param {string} applicationId Порядковый номер заявления в системе
   * @param {'inline' | 'attachment'} [type] Тип Content-Disposition выдачи файла (по умолчанию inline)
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ApplicationApiInterface
   */
  getFeePaymentDocumentRaw(
    requestParameters: GetFeePaymentDocumentRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Blob>>

  /**
   * Генерация платёжного поручения (PDF) на оплату госпошлины по заявке: первой пошлины — для заявок в статусе FE, второй — для заявок в статусе CompletedEOS; в остальных статусах генерация запрещена. Файл отдаётся потоком (Content-Type: application/pdf), а не в конверте success_response. Требуется подтверждённый email.
   * Платёжное поручение по пошлине (PDF)
   */
  getFeePaymentDocument(
    requestParameters: GetFeePaymentDocumentRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Blob>

  /**
   * Список классов МКТУ, выбранных в заявке: номера классов и наименования товаров/услуг (схема MktuClassShort из docs/api.yaml). Требуется подтверждённый email.
   * @summary Классы МКТУ заявки
   * @param {string} applicationId Порядковый номер заявления в системе
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ApplicationApiInterface
   */
  getMktuListRaw(
    requestParameters: GetMktuListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetMktuList200Response>>

  /**
   * Список классов МКТУ, выбранных в заявке: номера классов и наименования товаров/услуг (схема MktuClassShort из docs/api.yaml). Требуется подтверждённый email.
   * Классы МКТУ заявки
   */
  getMktuList(
    requestParameters: GetMktuListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetMktuList200Response>
}

/**
 *
 */
export class ApplicationApi
  extends runtime.BaseAPI
  implements ApplicationApiInterface
{
  /**
   * Проверка, требуется ли и возможна ли оплата госпошлины по заявке. Признак paymentAllowed собирается из двух независимых проверок: анализ статуса заявки и истории оплат через эквайринг (CheckUserCanPayAction) и флаг allow_fee_payment в jsonb-опциях заявки для полу-цифровых продуктов (CheckApplicationOptionsAllowPaymentAction). Оплата доступна, только если обе проверки пройдены. Требуется подтверждённый email.
   * Проверка возможности оплаты пошлины
   */
  async checkPaymentRequiredRaw(
    requestParameters: CheckPaymentRequiredRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CheckPaymentRequired200Response>> {
    if (requestParameters['applicationId'] == null) {
      throw new runtime.RequiredError(
        'applicationId',
        'Required parameter "applicationId" was null or undefined when calling checkPaymentRequired().'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('bearerToken', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }
    const response = await this.request(
      {
        path: `/api/v1/applications/{applicationId}/check-payment-required`.replace(
          `{${'applicationId'}}`,
          encodeURIComponent(String(requestParameters['applicationId']))
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CheckPaymentRequired200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Проверка, требуется ли и возможна ли оплата госпошлины по заявке. Признак paymentAllowed собирается из двух независимых проверок: анализ статуса заявки и истории оплат через эквайринг (CheckUserCanPayAction) и флаг allow_fee_payment в jsonb-опциях заявки для полу-цифровых продуктов (CheckApplicationOptionsAllowPaymentAction). Оплата доступна, только если обе проверки пройдены. Требуется подтверждённый email.
   * Проверка возможности оплаты пошлины
   */
  async checkPaymentRequired(
    requestParameters: CheckPaymentRequiredRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CheckPaymentRequired200Response> {
    const response = await this.checkPaymentRequiredRaw(
      requestParameters,
      initOverrides
    )
    return await response.value()
  }

  /**
   * Создание заказа на оплату госпошлины (первая/вторая пошлина по зТЗ) для объекта SysObject текущего пользователя; вместе с заказом создаётся платёж. Требуется подтверждённый email.
   * Заказ на оплату госпошлины
   */
  async createStateDutyOrderRaw(
    requestParameters: CreateStateDutyOrderOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PayOrder200Response>> {
    if (requestParameters['createStateDutyOrderRequest'] == null) {
      throw new runtime.RequiredError(
        'createStateDutyOrderRequest',
        'Required parameter "createStateDutyOrderRequest" was null or undefined when calling createStateDutyOrder().'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('bearerToken', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }
    const response = await this.request(
      {
        path: `/api/v1/orders/create-state-duty-order`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: CreateStateDutyOrderRequestToJSON(
          requestParameters['createStateDutyOrderRequest']
        ),
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PayOrder200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Создание заказа на оплату госпошлины (первая/вторая пошлина по зТЗ) для объекта SysObject текущего пользователя; вместе с заказом создаётся платёж. Требуется подтверждённый email.
   * Заказ на оплату госпошлины
   */
  async createStateDutyOrder(
    requestParameters: CreateStateDutyOrderOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PayOrder200Response> {
    const response = await this.createStateDutyOrderRaw(
      requestParameters,
      initOverrides
    )
    return await response.value()
  }

  /**
   * Удаление заявления текущего пользователя. Допускается только для заявлений в статусах Draft, Created и Create; при наличии хотя бы одного оплаченного ордера по заявке удаление запрещено. Требуется подтверждённый email.
   * Удаление заявки
   */
  async deleteApplicationRaw(
    requestParameters: DeleteApplicationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<DeleteApplication200Response>> {
    if (requestParameters['applicationId'] == null) {
      throw new runtime.RequiredError(
        'applicationId',
        'Required parameter "applicationId" was null or undefined when calling deleteApplication().'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('bearerToken', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }
    const response = await this.request(
      {
        path: `/api/v1/applications/{applicationId}`.replace(
          `{${'applicationId'}}`,
          encodeURIComponent(String(requestParameters['applicationId']))
        ),
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      DeleteApplication200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Удаление заявления текущего пользователя. Допускается только для заявлений в статусах Draft, Created и Create; при наличии хотя бы одного оплаченного ордера по заявке удаление запрещено. Требуется подтверждённый email.
   * Удаление заявки
   */
  async deleteApplication(
    requestParameters: DeleteApplicationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<DeleteApplication200Response> {
    const response = await this.deleteApplicationRaw(
      requestParameters,
      initOverrides
    )
    return await response.value()
  }

  /**
   * Полные данные карточки заявки текущего пользователя: статусы (текущий/прошлый), состояние документов, причина проблемы, номер регистрации и сертификата, данные правообладателя, изображение знака, аналитические документы по этапам, ссылка на источник ФИПС. Поле linkInAdmin возвращается только админским аккаунтам. Требуется подтверждённый email.
   * Данные заявки
   */
  async getApplicationRaw(
    requestParameters: GetApplicationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetApplication200Response>> {
    if (requestParameters['applicationId'] == null) {
      throw new runtime.RequiredError(
        'applicationId',
        'Required parameter "applicationId" was null or undefined when calling getApplication().'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('bearerToken', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }
    const response = await this.request(
      {
        path: `/api/v1/applications/{applicationId}`.replace(
          `{${'applicationId'}}`,
          encodeURIComponent(String(requestParameters['applicationId']))
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      GetApplication200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Полные данные карточки заявки текущего пользователя: статусы (текущий/прошлый), состояние документов, причина проблемы, номер регистрации и сертификата, данные правообладателя, изображение знака, аналитические документы по этапам, ссылка на источник ФИПС. Поле linkInAdmin возвращается только админским аккаунтам. Требуется подтверждённый email.
   * Данные заявки
   */
  async getApplication(
    requestParameters: GetApplicationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetApplication200Response> {
    const response = await this.getApplicationRaw(
      requestParameters,
      initOverrides
    )
    return await response.value()
  }

  /**
   * Выдача файла документа делопроизводства по заявке: поток с Content-Type и именем файла из документа (обычно application/pdf), а не конверт success_response. Служебные значения documentId — egr_document / extract_document — доступны только для заявок в статусе EGR. Требуется подтверждённый email.
   * Файл документа заявки
   */
  async getApplicationDocumentRaw(
    requestParameters: GetApplicationDocumentRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Blob>> {
    if (requestParameters['applicationId'] == null) {
      throw new runtime.RequiredError(
        'applicationId',
        'Required parameter "applicationId" was null or undefined when calling getApplicationDocument().'
      )
    }

    if (requestParameters['documentId'] == null) {
      throw new runtime.RequiredError(
        'documentId',
        'Required parameter "documentId" was null or undefined when calling getApplicationDocument().'
      )
    }

    const queryParameters: any = {}

    if (requestParameters['type'] != null) {
      queryParameters['type'] = requestParameters['type']
    }

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('bearerToken', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }
    const response = await this.request(
      {
        path: `/api/v1/applications/{applicationId}/documents/{documentId}`
          .replace(
            `{${'applicationId'}}`,
            encodeURIComponent(String(requestParameters['applicationId']))
          )
          .replace(
            `{${'documentId'}}`,
            encodeURIComponent(String(requestParameters['documentId']))
          ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.BlobApiResponse(response)
  }

  /**
   * Выдача файла документа делопроизводства по заявке: поток с Content-Type и именем файла из документа (обычно application/pdf), а не конверт success_response. Служебные значения documentId — egr_document / extract_document — доступны только для заявок в статусе EGR. Требуется подтверждённый email.
   * Файл документа заявки
   */
  async getApplicationDocument(
    requestParameters: GetApplicationDocumentRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Blob> {
    const response = await this.getApplicationDocumentRaw(
      requestParameters,
      initOverrides
    )
    return await response.value()
  }

  /**
   * Постраничный список заявок текущего пользователя. Сортировка — по дате последней загрузки документов (по убыванию). Если параметр status не передан, завершённые заявки (FILTER_STATUS_ISSUED) исключаются из выдачи. Рядом с data возвращаются pagination (мета пагинации) и meta (количество заявок по вкладкам статусов, без учёта фильтра status). Требуется подтверждённый email.
   * Список заявок пользователя
   */
  async getApplicationListRaw(
    requestParameters: GetApplicationListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetApplicationList200Response>> {
    const queryParameters: any = {}

    if (requestParameters['search'] != null) {
      queryParameters['search'] = requestParameters['search']
    }

    if (requestParameters['status'] != null) {
      queryParameters['status'] = requestParameters['status']
    }

    if (requestParameters['page'] != null) {
      queryParameters['page'] = requestParameters['page']
    }

    if (requestParameters['perPage'] != null) {
      queryParameters['perPage'] = requestParameters['perPage']
    }

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('bearerToken', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }
    const response = await this.request(
      {
        path: `/api/v1/applications`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      GetApplicationList200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Постраничный список заявок текущего пользователя. Сортировка — по дате последней загрузки документов (по убыванию). Если параметр status не передан, завершённые заявки (FILTER_STATUS_ISSUED) исключаются из выдачи. Рядом с data возвращаются pagination (мета пагинации) и meta (количество заявок по вкладкам статусов, без учёта фильтра status). Требуется подтверждённый email.
   * Список заявок пользователя
   */
  async getApplicationList(
    requestParameters: GetApplicationListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetApplicationList200Response> {
    const response = await this.getApplicationListRaw(
      requestParameters,
      initOverrides
    )
    return await response.value()
  }

  /**
   * Генерация платёжного поручения (PDF) на оплату госпошлины по заявке: первой пошлины — для заявок в статусе FE, второй — для заявок в статусе CompletedEOS; в остальных статусах генерация запрещена. Файл отдаётся потоком (Content-Type: application/pdf), а не в конверте success_response. Требуется подтверждённый email.
   * Платёжное поручение по пошлине (PDF)
   */
  async getFeePaymentDocumentRaw(
    requestParameters: GetFeePaymentDocumentRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Blob>> {
    if (requestParameters['applicationId'] == null) {
      throw new runtime.RequiredError(
        'applicationId',
        'Required parameter "applicationId" was null or undefined when calling getFeePaymentDocument().'
      )
    }

    const queryParameters: any = {}

    if (requestParameters['type'] != null) {
      queryParameters['type'] = requestParameters['type']
    }

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('bearerToken', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }
    const response = await this.request(
      {
        path: `/api/v1/applications/{applicationId}/fee-payment-document`.replace(
          `{${'applicationId'}}`,
          encodeURIComponent(String(requestParameters['applicationId']))
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.BlobApiResponse(response)
  }

  /**
   * Генерация платёжного поручения (PDF) на оплату госпошлины по заявке: первой пошлины — для заявок в статусе FE, второй — для заявок в статусе CompletedEOS; в остальных статусах генерация запрещена. Файл отдаётся потоком (Content-Type: application/pdf), а не в конверте success_response. Требуется подтверждённый email.
   * Платёжное поручение по пошлине (PDF)
   */
  async getFeePaymentDocument(
    requestParameters: GetFeePaymentDocumentRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Blob> {
    const response = await this.getFeePaymentDocumentRaw(
      requestParameters,
      initOverrides
    )
    return await response.value()
  }

  /**
   * Список классов МКТУ, выбранных в заявке: номера классов и наименования товаров/услуг (схема MktuClassShort из docs/api.yaml). Требуется подтверждённый email.
   * Классы МКТУ заявки
   */
  async getMktuListRaw(
    requestParameters: GetMktuListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetMktuList200Response>> {
    if (requestParameters['applicationId'] == null) {
      throw new runtime.RequiredError(
        'applicationId',
        'Required parameter "applicationId" was null or undefined when calling getMktuList().'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('bearerToken', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }
    const response = await this.request(
      {
        path: `/api/v1/applications/{applicationId}/get-mktu-list`.replace(
          `{${'applicationId'}}`,
          encodeURIComponent(String(requestParameters['applicationId']))
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      GetMktuList200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Список классов МКТУ, выбранных в заявке: номера классов и наименования товаров/услуг (схема MktuClassShort из docs/api.yaml). Требуется подтверждённый email.
   * Классы МКТУ заявки
   */
  async getMktuList(
    requestParameters: GetMktuListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetMktuList200Response> {
    const response = await this.getMktuListRaw(requestParameters, initOverrides)
    return await response.value()
  }
}

/**
 * @export
 * @enum {string}
 */
export enum GetApplicationDocumentTypeEnum {
  Inline = 'inline',
  Attachment = 'attachment',
}
/**
 * @export
 * @enum {string}
 */
export enum GetFeePaymentDocumentTypeEnum {
  Inline = 'inline',
  Attachment = 'attachment',
}
